import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type CustomSchedulesHolidayTypesGetContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/custom-schedules/holiday-types']['get'];

function mapCustomScheduleHolidayTypes(
  external: Utils.ArrayElement<
    CustomSchedulesHolidayTypesGetContract['responses']['200']['content']['application/json']['result']
  >,
): CustomerCommunication.CustomScheduleDestination {
  return {
    id: external.id,
    name: external.name,
  };
}

async function requestGetCustomScheduleHolidayTypes(brand: string) {
  if (!brand) {
    throw 'missing brand';
  }

  const url = makeCustomerCommunicationV1URL('/custom-schedules/holiday-types');
  url.searchParams.set('brand', brand);

  return request(url.toString(), {
    method: 'GET',
    credentials: 'include',
  })
    .then((response: CustomSchedulesHolidayTypesGetContract['responses']['200']['content']['application/json']) => {
      return response.result.map(mapCustomScheduleHolidayTypes);
    })
    .catch((error) => {
      throw JSON.stringify(error, null, 2);
    });
}

export default requestGetCustomScheduleHolidayTypes;
